/**
 * Created by intellicar-rinas on 24/10/17.
 */
import React, {Component} from 'react';
import './InGraphSet.css';
import InGraph from '../InGraph/InGraph2';
import InBarGraph from '../InBarGraph/InBarGraph';
import Dom from '../../../../helpers/Dom';
import {connect} from 'react-redux';
import actions from '../../../../store/actions'
import isGraphVisible from '../../../../Layouts/config/reports/historyReport/graphVisibilityConfig';
import _ from 'lodash';

class InGraphSet extends Component {

    state = {
        zoom:true,
        graphExpanded: false,
        graphLarge: false,
        mouseIn:false,
        refreshing: false
    };

    constructor(props){
        super(props);
        //
        // const toggleZoom = (action) => {
        //     this.setState({zoom: action});
        // }

        ['getGraphTool', 'getGraphToolbar', 'getButton'].map(i=>this[i]=this[i].bind(this));

        this.getGraphs = () => {
            return this.props.data && this.props.data.children ? this.props.data.children : []
        };

        window.refreshGraphs = () => {
            if(!this.mounted) return
            this.setState({ refreshing: true });
            setTimeout(()=> {
                this.setState({ refreshing: false });
            }, 100)
        }
        

        this.getGraphConfig = (tool) => {
            let {graphExpanded, graphLarge} = this.state;
            // let {graphExpanded, graphLarge} = this.props.graphSize;
            let rowSplit = graphExpanded ? 2 : 3;
            let colSplit = graphLarge ? 1 : 2;
            return {
                width: (this.props.data._position.width / colSplit) - 10,
                height: ((this.props.data._position.height - 45) / rowSplit) - 20,
                type: tool.graphType
            }
        };

        this.setRef = (tool, ref) =>{
            tool.ref = ref && ref.wrappedInstance ? ref.wrappedInstance : ref;
        };

        // window.addEventListener('keydown', e=>{
        //     if(e.keyCode === 17) {
        //         toggleZoom(true);
        //     }
        // })
        //
        // window.addEventListener('keyup', e=>{
        //     if(e.keyCode === 17) {
        //         toggleZoom(false);
        //     }
        // })


        this.resize =()=> {
            if(!this.mounted) return;
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(()=>{
                if(!this.mounted) return;
                this.forceUpdate();
            }, 500);
        };
        window.addEventListener('resize', ()=> {
            this.resize();
        });


        this.toggleCloseButton = () => {
            let state = this.props.graphSetState === 0 ? 100 : 0;
            this.props.closeButton (state === 0 ? false : true);
            this.props.dispatch({
                type:actions.GRAPHSET_STATE_CHANGED,
                data:state
            })
        };

        this.redrawGraphs = () => {
            this.getGraphs()
                .map(graph=>{
                    if(graph.ref) {
                        graph.ref.draw();
                    }
                })
        }

        this.toggleSemiCloseButton = () => {
            if(this.state.graphExpanded) {
                // this.props.dispatch({type:'GRAPH_EXPANDED'});
                window.expandGraphs(12);
                this.setState(state => ({graphLarge:!state.graphLarge}));
            } else {
                let state = this.props.graphSetState === 0 ? 50 : this.props.graphSetState === 50 ? 100 : 50;
                this.props.dispatch({
                    type:actions.GRAPHSET_STATE_CHANGED,
                    data:state
                });
            }
        };

        this.onVehicleChange =()=> {
            if(!this.mounted) return;
            this.vehicles = window.selectedVehicles;
            this.forceUpdate(()=>{
                this.getGraphs()
                    // .filter(graph=>{return isGraphVisible(graph, this.vehicles)})
                    .map(graph=>{
                        if(graph.ref) {
                            graph.ref.setNoData(true);
                        }
                    })
            });
        };

        window.addOnSaveVehicleStateListener('InGraphSet', this.onVehicleChange);
        this.onGraphMouseUp =graph=> {
            this.setState({focusGraph: graph})
        };
        this.clearAddress = () =>{
            if(this.state.mouseIn)
            document.querySelector(".ml-abx") ? document.querySelector(".ml-abx").style.display = 'none': null 
            this.setState({mouseIn: false})
        }
        this.onMouseIn = () => {
            document.querySelector(".ml-abx") ? document.querySelector(".ml-abx").style.display = 'inline-table' : null
            this.setState({mouseIn : true})
        }

        this.getFocusGraphName =()=> {
            // return this.state.focusGraph ? (this.state.focusGraph.name || this.state.focusGraph.key) : '';
            if(this.state.focusGraph) {
                let nameArr = [];
                for(let idx in this.state.focusGraph.config) {
                    nameArr.push(this.state.focusGraph.config[idx].name);
                }
                return nameArr.join(', ');
            }
            return '';
        }

    }

    getButton(config, index) {
        if(config.key !== 'graphDownload' || (this.props.userInfo && this.props.userInfo.SELF && this.props.userInfo.SELF.graph_rawdata_download === 'ENABLED')) {
            return (
                <div className="igstb-button" onClick={()=>config.onClick ? config.onClick(this.state.focusGraph, config) : null} key={index}>
                    {config.buttonName ? config.buttonName + ' ' : ''} <i className={config.icon}></i>
                </div>
            )
        }
    }

    getGraphToolbar() {
        return ((this.state.focusGraph ? this.state.focusGraph.graphToolBar : []) || [])
    }

    getGraphTool(tool, index) {
        let toolEl;

        switch (tool.type) {

            case 'BUTTON':
                toolEl = this.getButton(tool, index);
                break;

            default:
                toolEl = this.getButton(tool, index);

        }

        return toolEl;
    }

    componentDidMount(){
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    componentWillReceiveProps(props){
        this.vehicle = window.selectedVehicles;
        if(this.props.graphSetState !== props.graphSetState && props.graphSetState === 100 ){
            window.setMapSize({
                height: window.innerHeight - 50,
                width: window.innerWidth - 50,
                top: 45,
                left: 0,
              });
        }
        // if(this.props.graphSize.graphLarge !== props.graphSize.graphLarge || this.props.graphSize.graphExpanded !== props.graphSize.graphExpanded) {
        //     this.redrawGraphs();
        // }
    }
    componentDidUpdate(prevProps,prevState) {
        if(prevState.graphLarge !== this.state.graphLarge || prevState.graphExpanded !== this.state.graphExpanded) {
            this.redrawGraphs();
        }
    }

    toggleExpand = () => {
        // this.props.dispatch({type:'GRAPH_EXPANDED'});
        window.expandGraphs(this.state.graphExpanded ? 6 : 12);
        window.updateReportWindow();
        this.setState(state => ({graphExpanded:!state.graphExpanded}),function(){
            this.props.graphExpanded(this.state.graphExpanded);
        });
        
      
    }

    render() {
        let {graphExpanded,graphLarge} = this.state;
        // let {graphExpanded,graphLarge} = this.props.graphSize;
        let btn2cls = '';
        if(!graphExpanded) {
            btn2cls = 'fa fa-chevron-' + (this.props.graphSetState === 100 ? 'right' : 'left');
        } else btn2cls = graphLarge ? 'fa fa-th-large' : 'fa fa-bars';
        let advancedReports = _.get(window.userInfo, 'SELF.advanced_reports') !== 'HIDE';
        let graphs = this.getGraphs().filter(graph => {
            let visible = isGraphVisible(graph, this.vehicles);
            return visible;
        })
        return (
            <div className={Dom.Class({'exp':graphExpanded,'lgs':graphLarge,'full':this.props.graphSetState===100, 'half':this.props.graphSetState===50}, "InGraphSet")}>
                <div className="igs-toolbar">
                    <div className="igst-name">{this.getFocusGraphName()}</div>
                    {
                        this.getGraphToolbar().map((item, index)=>{
                            return this.getGraphTool(item, index);
                        })
                    }
                </div>
                <div className="igs-buttonSet">
                    <div className="igsb-button" onClick={this.toggleCloseButton}>
                        {
                            this.props.graphSetState === 0 ? (
                                <span className="fa fa-line-chart"></span>
                            ) : (
                                <span className="fa fa-times"></span>
                            )
                        }
                    </div>
                    {advancedReports && <div className="igsb-button" onClick={this.toggleSemiCloseButton}>
                        <span className={btn2cls}></span>
                    </div>}
                    <div className="igsb-button" onClick={this.toggleExpand}>
                        <span className={graphExpanded ? 'fa fa-compress' : 'fa fa-expand'}></span>
                    </div>
                </div>
                <div className={Dom.Class({'ghost':!this.state.zoom},"igs-container")}>
                    {
                        graphs
                            .map((graph, index)=>{
                                let rendered_graph = null;
                                const config = graph.config.filter(c => {
                                    if(c.condition && !c.condition(window.selectedVehicles[0])) return false;
                                    return true;
                                })
                                if(!this.state.refreshing) {
                                    if(graph.type === 'IN_BAR_GRAPH') {
                                        rendered_graph = <InBarGraph data={graph} resume={this.props.resume(graph)} saveState={this.props.saveState} schemaKey={this.props.schemaKey}
                                            config={this.getGraphConfig(graph)} ref={ref=>{this.setRef(graph, ref)}} key={index}/>;
                                    } else if(graph.type === 'IN_GRAPH') {
                                        rendered_graph = <InGraph data={graph} lines={config} resume={this.props.resume(graph)} saveState={this.props.saveState} schemaKey={this.props.schemaKey}
                                            config={this.getGraphConfig(graph)} ref={ref=>{this.setRef(graph, ref)}} key={index}/>;
                                    }
                                }
                                return (
                                    <div className={"igsc-item" + (this.state.focusGraph && this.state.focusGraph.key === graph.key ? ' focused' : '') + ' ' + graph.key}
                                        key={index} onMouseUp={()=>this.onGraphMouseUp(graph)} onMouseOver={this.onMouseIn} onMouseOut={this.clearAddress} >
                                        <div className="igsci-focus"></div>
                                        <div className="igsci-body">
                                            {rendered_graph}
                                        </div>
                                    </div>
                                )
                            })
                    }
                </div>
            </div>
        )
    }

}

const MapPropsToState = (state) => {
    return {
        graphSetState: state.graphSetState,
        userInfo: state.userInfo,
        graphSize: state.graphSize,
    }
};


export default connect(MapPropsToState)(InGraphSet);
// export default InGraphSet;